<template>
  <div style="height:100%; overflow: auto;"
   ref="container">
    <div class="pk-flex"
     style="flex-wrap:wrap">
      <div v-for="(it,i) in items"
       :style="boxWrapperStyle"
       :key="'tn' + i">
        <div :title="getTitle(it)"
         class="pk-thumbnail-item-container pk-flex__vh-center"
         :class="thumbnailIdx === i ? 'active' : ''"
         v-on:click="clickImage(it)">
          <div v-if="!it.imgObj && !it.document.$_missing"
           style="height:50px; font-size:9px;"
           class="pk-flex__vh-center text-center">
            <div>No Image available</div>
          </div>
          <div v-if="it.imgObj && !it.imgObj.dbImageInfo.thumbnail && it.imgObj.dbImageInfo.name">
            <img src="../../assets/icons/loading.gif"
             style="height:10px">
            <div>
              <span style="font-size:8px"> {{it.imgObj.dbImageInfo.sourcename}}</span>
            </div>
          </div>
          <span style="font-size:8px"
           v-if="it.document.$_missing">Missing</span>
          <img v-if="it.imgObj"
           style="max-height: 100%; max-width: 100%;"
           :src="it.imgObj.dbImageInfo.thumbnail">
        </div>
      </div>
      <div v-if="items.length < 1">No image found</div>
    </div>
    <div class="pk-thumbnail-toolbar pk-flex__h-center">
      <img class="pk-thumbnail-toolbar-img" src="../../assets/icons/first.svg"
       @click="toLeft">
      <img class="pk-thumbnail-toolbar-img" :style="'opacity:'+(thumbnailIdx > 0 ? '1' : '0.4')"
       src="../../assets/icons/previous.svg"
       @click="selectImgByIdx(-1)">
      <img class="pk-thumbnail-toolbar-img" :style="'opacity:'+(thumbnailIdx < items.length - 1 ? '1' : '0.4')"
       src="../../assets/icons/next.svg"
       @click="selectImgByIdx(1)">
      <img class="pk-thumbnail-toolbar-img" src="../../assets/icons/last.svg"
       @click="toRight">
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import * as $ from 'jquery';

export default Vue.extend({
  props: {
    items: Array,
    colCount: Number,
    rowCount: Number
  },
  data() {
    return {
      selectedItem: null,
      selectedIdx: 0,
      parentHeight: 100,
      parentWidth: 100,
    };
  },
  // created() {},
  mounted() {
    const vue = this;

    const resize = () => {
      vue.parentHeight = $(vue.$refs.container).height();
      vue.parentWidth = $(vue.$refs.container).width();
    };
    window.addEventListener('resize', () => {
      resize();
    });
    resize();
    if (this.$route.query.thumbnail) {
      this.clickImageByIndex(parseInt(this.$route.query.thumbnail, 10), 'begin');
      // this.$routerUpdateQuery(this, {
      //   thumbnail: 'delete'
      // });
    }

  },
  // updated() {},
  computed: {
    _rowCount() {
      return this.rowCount ? this.rowCount : 6;
    },
    boxWrapperStyle() {
      return 'height:' + (this.parentWidth / this.colCount) + 'px; padding: 2px; flex:0 0 ' + (100 / this.colCount) + '%';
    },
    thumbnailIdx() {
      const idx = this.$route.query['thumbnail'];
      return parseInt(idx, 10) ? parseInt(idx, 10) : 0;
    },
    viewNavItems() {
      return this.$store.getters['archive/viewNavItems'];
    },
  },
  methods: {
    selectImgByIdx(i) {
      const si = this.selectedIdx;
      const idx = si + i;
      if (idx < 0 || idx > this.items.length - 1) {
        return;
      }
      this.selectedIdx = idx;
      this.clickImage(this.items[idx]);
    },
    toLeft() {
      this.selectedIdx = 0;
      this.clickImage(this.items[0]);
    },
    toRight() {
      const l = this.items.length - 1;
      this.clickImage(this.items[l]);
    },
    getTitle(item) {
      const activeItem = this.viewNavItems.find(a => a.active === true);
      let ret = item.imgObj ? item.imgObj.sourcename : '';
      if (activeItem.id === 'ss') {
        return ret;
      } else {
        ret = ret.split('@');
        ret[ret.length - 1] = ret[ret.length - 1].split('.')[0];
        return ret[ret.length - 1];
      }
    },
    clickImage(o) {
      // console.log(this.items);
      this.selectedItem = o;
      this.selectedIdx = this.items.indexOf(o);
      this.$routerUpdateQuery(this, {
        thumbnail: this.selectedIdx
      });
    },
    clickImageByIndex(i, from) {
      if (this.items[i]) {
        this.selectedItem = this.items[i];
        if (from !== 'begin') {
          this.$routerUpdateQuery(this, {
            thumbnail: i
          });
        }
      }
    }
  }
});
</script>

<style>
  .pk-thumbnail-toolbar-img {
    margin: 25px;
    height: 25px;
  }
  .pk-thumbnail-toolbar-img:hover {
    margin: 25px;
    height: 25px;
    background-color: #eee;
    cursor: pointer;
  }
  
  /* .pk-thumbnail-toolbar {} */
  
  .pk-thumbnail-item-container {
    background-color: #ddd;
    height: 100%;
    width: 100%;
    cursor: pointer;
    border: 3px solid transparent;
  }
  
  .pk-thumbnail-toolbar img:hover {
    border: 1px solid #eee;
  }
  
  .pk-thumbnail-item-container.active {
    border: 3px solid #5a83bb;
  }
</style>
